/* eslint-disable no-useless-escape */
import moment from 'moment'
import objectEnum from '@/config/object.env'

const changeTypeData = {
    async checkRequired(input) {
        if (!input) {
            return false;
        }
        return true;
    },

    async containsSQLInjection(input) {

        // /[-'";\(\)\{\}\[\]]/,
        //Các mẫu phổ biến của SQL injection
        const sqlInjectionPatterns = [
            /(\b(ALTER|CREATE|DELETE|DROP|EXEC(UTE)?|INSERT( +INTO)?|SELECT|UPDATE)\b)|(\b(UNION( +ALL)?)\b)/i,
            /(\b(CONCAT|GROUP_CONCAT|LENGTH|SUBSTRING|IFNULL|IF\s*?\())/i,
        ];

        //Kiểm tra chuỗi với từng mẫu
        for (const pattern of sqlInjectionPatterns) {
            if (pattern.test(input)) {
                return true; //Chuỗi có chứa mẫu SQL injection
            }
        }

        return false; //Chuỗi an toàn
    },

    async fromDatetoString(input) {
        if (input.getMonth() + 1 >= 10) {
            return input.getDate() + "/" + (input.getMonth() + 1) + "/" + input.getFullYear();
        }
        else {
            return input.getDate() + "/0" + (input.getMonth() + 1) + "/" + input.getFullYear();
        }
    },

    async fromExcelNumbertoDate(input) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000; // Số mili giây trong một ngày
        const excelEpochDiff = 25569; // Số ngày từ 1/1/1900 đến 1/1/1970
        const timezoneOffset = 7 * 60; // Độ chênh lệch múi giờ (7 giờ)

        const excelTimestamp = (input - excelEpochDiff) * millisecondsPerDay;
        const gmtTimestamp = excelTimestamp - (timezoneOffset * 60 * 1000);
        return new Date(gmtTimestamp);
    }
}

const correctData = {
    async handleStringImport(input, required) {
        if (required) {
            if (!await changeTypeData.checkRequired(input))
                return "Error: Dữ liệu bắt buộc";
        }
        if (!input) {
            return null;
        }
        else {
            if (await changeTypeData.containsSQLInjection(input)) {
                return "Error: Chuỗi chứa dữ liệu không phù hợp "
            }
            else return input.toString();
        }
    },

    async handleBooleanImport(input, required) {
        if (required) {
            if ((typeof input === 'boolean') && (!await changeTypeData.checkRequired(input.toString())))
                return "Error: Dữ liệu bắt buộc";
                if (input == undefined) {
                    return "Error: Dữ liệu bắt buộc";
                }
        }

        if (input == undefined) {
            return null;
        }
        else if(typeof input === 'boolean'){
            switch (input){
                case true:
                    return "TRUE"
                case false:
                    return "FALSE"
                default:
                    break
            }
        }
        else {
            let stringInput = input.toString().toUpperCase();
            if (stringInput == "TRUE" || input.toString() == "1")
                return "TRUE";
            else if (stringInput == "FALSE" || input.toString() == "0")
                return "FALSE";
            else return "Error: " + input;
        }
    },

    async handleIntImport(input, required) {
        if (required) {
            if (!await changeTypeData.checkRequired(input))
                return "Error: Dữ liệu bắt buộc";
        }
        if (input == undefined) {
            return null;
        }
        else {
            if (Number.isSafeInteger(input)) {
                let val = parseInt(input);
                if (val < Number.MAX_SAFE_INTEGER)
                    return val.toString();
                else return "Error: Giá trị quá lớn!";
            }
            else if(!isNaN(parseInt(input)) && (parseInt(input).toString() == input) )
            {
                return input
            }
            else {

                return "Error: " + input.toString();
            }

        }
    },

    async handleSmallIntImport(input, required) {
        if (required) {
            if (!await changeTypeData.checkRequired(input))
                return "Error: Dữ liệu bắt buộc";
        }
        if (input == undefined) {
            return null;
        }
        else {
            if (Number.isInteger(input)) {
                let val = parseInt(input);
                if (val < 32767)
                    return val.toString();
                else return "Error: Giá trị quá lớn!";
            }
            else {

                return "Error: " + input.toString();
            }

        }
    },

    async handleTinyIntImport(input, required) {
        if (required) {
            if (!await changeTypeData.checkRequired(input))
                return "Error: Dữ liệu bắt buộc";
        }
        if (input == undefined) {
            return null;
        }
        else {
            if (Number.isInteger(input)) {
                let val = parseInt(input);
                if (val < 127)
                    return val.toString();
                else return "Error: Giá trị quá lớn!";
            }
            else {

                return "Error: " + input.toString();
            }

        }
    },

    async handleFloatImport(input, required) {
        if (required) {
            if (!await changeTypeData.checkRequired(input))
                return "Error: Dữ liệu bắt buộc";
        }
        if (input == undefined) {
            return null;
        }
        else {
            if (typeof input == 'number') {
                let val = parseFloat(input);
                if (val <= Number.MAX_VALUE)
                    return val.toString();
                else return "Error: Giá trị quá lớn!";
            }
            else {

                return "Error: " + input.toString();
            }

        }
    },

    async handleDateImport(input, required) {
        if (required) {
            if (!changeTypeData.checkRequired(input))
                return "Error: Dữ liệu bắt buộc";
        }
        if (!input) {
            return null;
        }
        else {
            let parseValue = parseInt(input);
            if (typeof input != "number") {
                var newDateTime = moment(input, "DD/MM/YYYY").toDate();
                if (isNaN(newDateTime)) {
                    return "Error: " + input;
                }
                else {
                    return await changeTypeData.fromDatetoString(newDateTime);
                }
            }

            else {
                const millisecondsPerDay = 24 * 60 * 60 * 1000; // Số mili giây trong một ngày
                const excelEpochDiff = 25569; // Số ngày từ 1/1/1900 đến 1/1/1970
                const timezoneOffset = 7 * 60; // Độ chênh lệch múi giờ (7 giờ)

                const excelTimestamp = (input - excelEpochDiff) * millisecondsPerDay;
                const gmtTimestamp = excelTimestamp - (timezoneOffset * 60 * 1000);
                let value = new Date(gmtTimestamp);
                return await changeTypeData.fromDatetoString(value);
            }
        }
    },

    async handleOnlyRequiredImport(input) {
        if (!changeTypeData.checkRequired(input))
            return "Error: Dữ liệu bắt buộc";
        else return input
    }


}
const actions = {
    async handleTypeImport({ dispatch }, { input, typeData, required }) {
        if (typeData == objectEnum.handleData.REQUIRED_ONLY)
            return await correctData.handleOnlyRequiredImport(input);
        if (typeData == objectEnum.handleData.STRING)
            return await correctData.handleStringImport(input, required);
        if (typeData == objectEnum.handleData.BOOLEAN)
            return await correctData.handleBooleanImport(input, required);
        if (typeData == objectEnum.handleData.TINYINT)
            return await correctData.handleTinyIntImport(input, required);
        if (typeData == objectEnum.handleData.SMALLINT)
            return await correctData.handleSmallIntImport(input, required);
        if (typeData == objectEnum.handleData.INT)
            return await correctData.handleIntImport(input, required);
        if (typeData == objectEnum.handleData.FLOAT)
            return await correctData.handleFloatImport(input, required);
        if (typeData == objectEnum.handleData.DATE)
            return await correctData.handleDateImport(input, required);
    }
}

export const handleData = {
    namespaced: true,
    changeTypeData,
    actions,
};
